import { useHover } from '@elotech/components';
import classnames from 'classnames';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router';

const CollapsibleMenu = ({ menuItem, children, location, getIsHover }) => {
  const ulRef = useRef(null);

  const [refHover, isHover] = useHover();
  const [ulStyle, setUlStyle] = useState({});
  const [collapsed, setCollapsed] = useState(true);

  useLayoutEffect(() => {
    const node = refHover.current;
    if (node) {
      const child = node.querySelector('ul');
      if (child) {
        let childHeight = child.offsetHeight;
        const bounding = node.getBoundingClientRect();
        let offsetTop = bounding.y;
        const windowHeight = window.innerHeight;
        if (childHeight > windowHeight) {
          childHeight = windowHeight - 310;
        }
        if (offsetTop + childHeight > windowHeight) {
          offsetTop = offsetTop - (offsetTop + childHeight - windowHeight) - 5;
        }

        setUlStyle({
          left: `${bounding.x + bounding.width}px`,
          maxHeight: childHeight ? `${childHeight}px` : undefined,
          top: `${offsetTop}px`
        });
      }
    }
  }, [refHover, isHover]);

  useEffect(() => {
    getIsHover(isHover);
  }, [isHover, getIsHover]);

  const onClickNewTheme = event => {
    event.preventDefault();
    event.stopPropagation();

    setCollapsed(prevState => !prevState);
  };

  const classesli = classnames({
    'dropdown-arrow': true,
    'top open': !collapsed
  });

  const classesul = classnames({
    active: !collapsed
  });

  const menuGroupAtivoBySubmenu = menuItem
    .get('submenus')
    .toJS()
    .map(submenu => submenu.route)
    .some(submenuRoute => submenuRoute === location.pathname);

  const classesliNewTheme = classnames({
    on: menuGroupAtivoBySubmenu
  });

  return (
    <li ref={refHover} className={classesliNewTheme}>
      <a className={classesli} onClick={onClickNewTheme} href="#0">
        <i className={classnames(menuItem.get('image'), 'father')} />
        <b>{menuItem.get('menu')}</b>
      </a>

      <ul
        ref={ulRef}
        style={ulStyle}
        attr-parent={menuItem.get('menu')}
        className={classesul}
      >
        {children}
      </ul>
    </li>
  );
};

export default withRouter(CollapsibleMenu);
